// projectsConfig.js — Shoval Roymi projects, ordered by visual impact.

export const projectsConfig = [
  {
    id: 13,
    title: 'קובייה מרחפת',
    subtitle: 'מינימליזם על-זמני',
    category: 'מודרני מינימליסטי',
    folderName: 'קובייה מרחפת',
    imageCount: 6,
    thumbnailIndex: 1,
    description:
      'בית פרטי בעיצוב מודרני ונקי, המבוסס על ניגודיות בין בטון חשוף בקומה העליונה לבין טיח לבן ורך בקומת הקרקע.\n' +
      'הקומה העליונה יוצרת תחושת "קובייה מרחפת", בעוד קומת הקרקע נפתחת לחוץ עם ויטרינות רחבות ואור טבעי.\n' +
      'הפנים ממשיך את השפה האחידה עם גוונים בהירים, חומרים טבעיים ותאורה נסתרת, לצד חיבור ישיר בין פנים לחוץ.\n' +
      'פרויקט מינימליסטי, מדויק ועל-זמני, המשלב חומריות גולמית עם יוקרה שקטה.',
  },
  {
    id: 2,
    title: 'קרווילות במדבר',
    subtitle: 'מתחם אירוח בנגב',
    category: 'אדריכלות נוף',
    folderName: 'קרווילות צימרים',
    imageCount: 8,
    thumbnailIndex: 1,
  },
  {
    id: 1,
    title: 'בית של יוקרה וחומר',
    subtitle: 'גליל תחתון',
    category: 'מודרני חם',
    folderName: 'בית של יוקרה וחומר',
    imageCount: 4,
    thumbnailIndex: 1,
  },
  {
    id: 5,
    title: 'בית של אור ועיצוב',
    subtitle: 'חלל שטוף אור',
    category: 'מודרני רך',
    folderName: 'בית של אור ועיצוב',
    imageCount: 7,
    thumbnailIndex: 2,
  },
  {
    id: 7,
    title: 'בית מדברי מודרני',
    subtitle: 'קו נקי במדבר',
    category: 'מדברי',
    folderName: 'בית מדברי מודרני',
    imageCount: 12,
    thumbnailIndex: 4,
  },
  {
    id: 6,
    title: 'בית של עץ ואור',
    subtitle: 'חימום על ידי חומר',
    category: 'טבעי חם',
    folderName: 'בית של עץ ואור',
    imageCount: 8,
    thumbnailIndex: 2,
  },
  {
    id: 11,
    title: 'בית של שקט ואור',
    subtitle: 'אטמוספירה מינורית',
    category: 'מינימליסטי',
    folderName: 'בית של שקט ואור',
    imageCount: 5,
    thumbnailIndex: 2,
  },
  {
    id: 3,
    title: 'בית של טבע וחומר',
    subtitle: 'הערבה',
    category: 'טבעי',
    folderName: 'בית של טבע וחומר',
    imageCount: 8,
    thumbnailIndex: 2,
  },
  {
    id: 10,
    title: 'בית של אור ורוגע',
    subtitle: 'פנים שלווים',
    category: 'מודרני שלו',
    folderName: 'בית של אור ורוגע',
    imageCount: 5,
    thumbnailIndex: 2,
  },
  {
    id: 4,
    title: 'בית בקוביות מודרניות',
    subtitle: 'קומפוזיציה גיאומטרית',
    category: 'מודרני',
    folderName: 'בית בקוביות מודרניות',
    imageCount: 7,
    thumbnailIndex: 1,
  },
  {
    id: 8,
    title: 'בית קובייתי עם חצר שקועה',
    subtitle: 'פטיו מדברי',
    category: 'מדברי',
    folderName: 'בית קובייתי מדברי עם חצר שקועה',
    imageCount: 12,
    thumbnailIndex: 1,
  },
  {
    id: 9,
    title: 'בית בקווים נקיים',
    subtitle: 'מינימליזם אדריכלי',
    category: 'מינימליסטי',
    folderName: 'בית בקווים נקיים',
    imageCount: 5,
    thumbnailIndex: 1,
  },
  {
    id: 12,
    title: 'בית של קוביות ועץ',
    subtitle: 'גיאומטריה וחומר',
    category: 'מודרני חם',
    folderName: 'בית של קוביות ועץ',
    imageCount: 4,
    thumbnailIndex: 1,
  },
];
